import React from "react";
import "./modal.scss";
import PuffLoader from "react-spinners/PuffLoader";
import { getCoupon, postCouponData } from "../../../utilities/services";
import { getCredentials } from "../../../utilities/credentials";

const Modal = ({
  children,
  show,
  setShow,
  modalData,
  credentialNumber,
  loading,
  setCredentialNumber,
  setShowCode,
  setCouponData,
  setCredentialStatus,
  setLoading,
}) => {
  const mostrarCodigo = async () => {
    setShowCode(true);
    setLoading(true);
    const credentials = await getCredentials(credentialNumber);
    setCredentialStatus(credentials?.data?.status);
    setShow(false);
    if (credentials?.data?.status === 1) {
      const coupon = await getCoupon(modalData?.id);
      setCouponData(coupon);
      setLoading(false);
      if (coupon.cupon !== undefined) {
        postCouponData(coupon?.cupon[0].id, credentialNumber);
      }
      if (coupon.cupon[0] === null || credentials === undefined) {
        setCredentialStatus(0);
        setLoading(false);
      }
    }
    setLoading(false);
  };
  return (
    <div className={`${show ? "appear" : "disappear"} modal`}>
      {loading ? (
        <div className="align-center">
          <PuffLoader size={75} color={"#F32A24"} loading={loading} />
        </div>
      ) : (
        <>
          <button
            className="modal-close btn btn-white btn-border-none align-end"
            id="close"
            onClick={() => setShow(false)}
          >
            X
          </button>
          <div className="image">
            <img
              src={`https://comerciosclub.lavoz.com.ar/${modalData?.logo}`}
              alt="Descuentos de Club La voz"
            />
          </div>
          <h4>{modalData?.descuento}% de descuento</h4>
          <div className="modal-info">
            <p className="bolder">Pagando con:</p>
            <p>Todos los medios de pago</p>
          </div>
          <div className="modal-info">
            <p className="bolder">Los días:</p>
            <p>{modalData.dias}</p>
            <p>
              Válido desde {modalData.fecha_alta} hasta {modalData.fecha_baja}
            </p>
          </div>
          <div className="modal-info">
            <p className="bolder">Válido en:</p>
            <p>{modalData?.valido_en}</p>
          </div>
          <div className="align-between show-code">
            <input
              value={credentialNumber}
              inputMode="numeric"
              onChange={(e) => {
                setCredentialNumber(e.target.value);
              }}
              className="card-code"
              type="text"
              id={`marca${modalData.id}`}
              minLength="19"
              maxLength="19"
              placeholder="Ingresá el código de tu tarjeta CLV"
            />
            <button
              onClick={() => {
                mostrarCodigo();
              }}
              value="Ingresá el código de tu tarjeta CLV"
              className="btn btn-blue"
            >
              Obtener mi Código
            </button>
          </div>
          <div className="align-center mt-1">Ver Bases y Condiciones</div>
        </>
      )}
    </div>
  );
};

export default Modal;
